export const DELETE_REPLACEMENT_TEXT = {
	title: 'Delete this replacement?',
	content: 'Once this replacement is deleted, it can not be undone!',
	cancelButton: 'Cancel',
	confirmButton: 'Delete',
};
